export const getParticle = (text: string) => {
    const lastChar = text.charAt(text.length - 1);
    const lastCharCode = lastChar.charCodeAt(0);
    const isKorean = lastCharCode >= 0xac00 && lastCharCode <= 0xd7a3;

    if (isKorean) {
        const hasFinalConsonant = (lastCharCode - 0xac00) % 28 !== 0;
        return hasFinalConsonant ? '은' : '는';
    }

    return '는';
};